import { motion } from 'framer-motion';
import { Coffee, Inbox } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface EmptyFeedProps {
  variant: 'empty' | 'slow' | 'end';
}

export function EmptyFeed({ variant }: EmptyFeedProps) {
  const { t } = useTranslation();

  const config = {
    empty: {
      icon: Inbox,
      title: t('feed.empty'),
      subtitle: t('feed.emptySubtitle'),
    },
    slow: {
      icon: Coffee,
      title: t('feed.slowDay'),
      subtitle: t('feed.slowDaySubtitle'),
    },
    end: {
      icon: Coffee,
      title: t('feed.endOfFeed'),
      subtitle: t('feed.endOfFeedSubtitle'),
    },
  }[variant];

  const Icon = config.icon;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col items-center justify-center py-16 px-4 text-center"
    >
      <div className="w-16 h-16 bg-[#F4F2F2] rounded-full flex items-center justify-center mb-6">
        <Icon className="w-8 h-8 text-[#E94E1B]" />
      </div>
      <h3 className="font-serif text-xl text-[#2E2A23] mb-2">{config.title}</h3>
      <p className="text-[#888185] text-sm max-w-xs">{config.subtitle}</p>
    </motion.div>
  );
}
